import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box, CircularProgress, IconButton } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const ReplyDialog = ({ open, onClose, content, isLoading }) => {
    const handleCopy = () => {
        navigator.clipboard.writeText(content);
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Generated Reply Suggestion</DialogTitle>
            <DialogContent dividers>
                {isLoading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', my: 5 }}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <Typography sx={{ whiteSpace: 'pre-wrap' }}>{content}</Typography>
                )}
            </DialogContent>
            <DialogActions>
                <IconButton onClick={handleCopy} disabled={isLoading || !content}>
                    <ContentCopyIcon />
                </IconButton>
                <Button onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ReplyDialog;
